import React, { useContext, useEffect, useState } from "react";
import { Data } from "../App";

export default function Filter() {
  const { rawList, filteredList, setFilteredList } = useContext(Data);
  const [colorFilter, setColorFilter] = useState([]);
  const [washFilter, setWashFilter] = useState([]);
  const [filterShow, setFilterShow] = useState(false);

  // チェックボックスの色に使う
  const colorList = {
    ベージュ系: "#E5E2D2",
    グリーン系: "#37722F",
    グレー系: "#838383",
    ブルー系: "#3247E5",
    "ホワイト、アイボリー系": "#FFF2F3",
    ブラック系: "#292929",
    ブラウン系: "#815A41",
    イエロー系: "#B9B04B",
    ダークブラウン系: "#46290D",
    その他: "#cdcccc",
  };

  // フィルタ処理
  useEffect(() => {
    let filteredData = rawList;
    if (colorFilter.length > 0) {
      filteredData = colorFilter.reduce((acc, cf) => {
        const colorFiltered = rawList.filter((item) => item.colorgroup === cf);
        return [...acc, ...colorFiltered];
      }, []);
    }
    if (washFilter.length > 0) {
      const washFilters = {
        machine: (item) => item.Function2 !== "",
        hand: (item) => item.Function3 !== "",
        dry: (item) => item.Function4 !== "",
      };
      filteredData = filteredData.reduce((acc, item) => {
        const washFiltered = washFilter.filter((wf) => washFilters[wf](item));
        if (washFiltered.length > 0 && !acc.includes(item)) {
          acc.push(item);
        }
        return acc;
      }, []);
    }
    filteredData.sort((a, b) => a.id - b.id);
    setFilteredList(filteredData);
  }, [rawList, colorFilter, washFilter]);

  // 各checkbox選択処理
  function checkColorFilter(color) {
    if (colorFilter.includes(color)) {
      let n = colorFilter.indexOf(color);
      setColorFilter(colorFilter.slice(0, n).concat(colorFilter.slice(n + 1)));
    } else {
      setColorFilter([...colorFilter, color]);
    }
  }
  function checkWashFilter(wash) {
    if (washFilter.includes(wash)) {
      let n = washFilter.indexOf(wash);
      setWashFilter(washFilter.slice(0, n).concat(washFilter.slice(n + 1)));
    } else {
      setWashFilter([...washFilter, wash]);
    }
  }

  // 絞り込み検索窓UI
  return (
    <section className="filter_container">
      <a
        className="filter_toggle_btn"
        onClick={() => setFilterShow(filterShow ? false : true)}
      >
        <b>絞り込み条件</b>
        <span className={filterShow ? "show" : ""}></span>
      </a>
      <div className={filterShow ? "inner show" : "inner"}>
        <div className="color">
          <h4>
            COLOR<span>カラーで選ぶ</span>
          </h4>
          <ul>
            {Object.keys(colorList).map((color, i) => {
              return (
                <li key={i}>
                  <label>
                    <input
                      type="checkbox"
                      value={color}
                      onChange={() => checkColorFilter(color)}
                      checked={colorFilter.includes(color) ? true : false}
                    />
                    <span
                      style={{ backgroundColor: colorList[color] }}
                      className={colorFilter.includes(color) ? "checked" : ""}
                    ></span>
                    <p>{color}</p>
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="wash">
          <h4>
            WASH<span>洗い方で選ぶ</span>
          </h4>
          <ul>
            <li>
              <label>
                <input
                  type="checkbox"
                  onChange={() => checkWashFilter("machine")}
                  checked={washFilter.includes("machine") ? true : false}
                />
                <span
                  className={washFilter.includes("machine") ? "checked" : ""}
                ></span>
                <p>洗濯機可</p>
              </label>
            </li>
            <li>
              <label>
                <input
                  type="checkbox"
                  onChange={() => checkWashFilter("hand")}
                  checked={washFilter.includes("hand") ? true : false}
                />
                <span
                  className={washFilter.includes("hand") ? "checked" : ""}
                ></span>
                <p>手洗い可</p>
              </label>
            </li>
            <br />
            <li>
              <label>
                <input
                  type="checkbox"
                  onChange={() => checkWashFilter("dry")}
                  checked={washFilter.includes("dry") ? true : false}
                />
                <span
                  className={washFilter.includes("dry") ? "checked" : ""}
                ></span>
                <p>ドライクリーニング可</p>
              </label>
            </li>
          </ul>
        </div>
        <p>
          該当<span>{filteredList.length}</span>件
        </p>
      </div>
    </section>
  );
}
